import { ConditionalRuleMode } from "V2.0/HomePages/PipelinesV2/PipelineBuilderV2/Models/Conditional";
import ConditionRulesExecution from "./ConditionRules";

export default ConditionalExecution;

const ConditionalModeExecutionRegistry = {
  [ConditionalRuleMode.RULES]: ConditionRulesExecution,
};

function ConditionalExecution(props) {
  const { node } = props;

  const ConditionModeExecution =
    ConditionalModeExecutionRegistry[node.data.mode];

  return <ConditionModeExecution {...props} />;
}
